<div [ngStyle]="{'width.px': width}" lf-body>
  <ng-container *ngIf="hasInitError()">
    <p class="print-text-group" style="text-align: center">{{initErrorMsg}}</p>
  </ng-container>
  <ng-container *ngIf="!hasInitError()">
    <ng-container>
      <span><strong>{{docTotal}}</strong>{{ 'lf_fileset_num_documents' | localize: lfFilesetLocalizeHelper }}</span>
    </ng-container>
    <ng-container *ngFor="let dType of viewModel.types">
      <p class="print-text-group">
        <span *ngIf="dType.id != '_none_' || (dType.files.length != 0 && viewModel.types.length > 1)" lf-label>{{dType.name}}</span><span *ngIf="isTypeRequired(dType.id)" class="required-star">*</span>
        <span *ngIf="dType.id != '_none_' && dType.min != dType.max">{{ { key: 'lf_fileset_type_requirements', args: [dType.min, dType.max] } | localize: lfFilesetLocalizeHelper }}</span>
        <span *ngIf="dType.id != '_none_' && dType.min == dType.max">{{ { key: 'lf_fileset_type_requirements_same_min_max', args: [dType.max] } | localize: lfFilesetLocalizeHelper }}</span>
        <br *ngIf="dType.id != '_none_' || (dType.files.length != 0 && viewModel.types.length > 1)">
        <!-- Individual Files -->
        <ng-container *ngFor="let dFile of dType.files; index as i">
            {{dFile.name}}
            <br>
            <ng-container *ngFor="let dHeader of viewModel.columns">
              <span *ngIf="dHeader.key == 'status'" class="col-tab">{{dHeader.header}}: {{getStatusDisplay(dFile.status)}}</span>
              <span *ngIf="dHeader.key != 'status'" class="col-tab">{{dHeader.header}}: {{dHeader.cell(dFile)}}</span>
              <br>
            </ng-container>
            <br *ngIf="!isLastFile(dType.files, i)">
        </ng-container>
      </p>
    </ng-container>
  </ng-container>
</div>